import moment from 'moment';

import DTO from './DTO';
import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';
import InsurerDTO from './InsurerDTO';
import { required } from '../utils/validation';
import { USER_TYPE } from '../configs';

class DriverDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'driver_last_name',
        type: String,
        validators: [],
        labelKey: 'last_name',
      },
      {
        name: 'driver_first_name',
        type: String,
        validators: [],
        labelKey: 'first_name',
      },
      {
        name: 'driver_middle_name',
        type: String,
        validators: [],
        labelKey: 'middle_name',
      },
      {
        name: 'driver_external_id',
        type: String,
        validators: [],
        labelKey: 'driver.external_id',
      },
      {
        name: 'driver_inn',
        type: String,
        validators: [],
        labelKey: 'inn',
      },
      {
        name: 'driver_birth_date',
        type: String,
        validators: [],
        labelKey: 'birth_date',
      },
      {
        name: 'driver_citizenship',
        type: String,
        validators: [],
        labelKey: 'citizenship',
      },
      {
        name: 'driver_phone',
        type: String,
        validators: [],
        labelKey: 'phone',
      },
      {
        name: 'driver_email',
        type: String,
        validators: [],
        labelKey: 'email',
      },
      {
        name: 'driver_identity_type',
        type: String,
        validators: [],
        labelKey: 'identity_type_short',
      },
      {
        name: 'driver_identity_number',
        type: String,
        validators: [],
        labelKey: 'identity_number',
      },
      {
        name: 'driver_identity_series',
        type: String,
        validators: [],
        labelKey: 'identity_series',
      },
      {
        name: 'driver_birth_place',
        type: String,
        validators: [],
        labelKey: 'place_of_birth',
      },
      {
        name: 'driver_identity_issue_date',
        type: String,
        validators: [],
        labelKey: 'identity_issue_date',
      },
      {
        name: 'driver_identity_issuer',
        type: String,
        validators: [],
        labelKey: 'identity_issuer',
      },
      {
        name: 'driver_identity_issuer_code',
        type: String,
        validators: [],
        labelKey: 'identity_issuer_code',
      },
      {
        name: 'driver_photo_with_identity',
        type: String,
        validators: [],
        labelKey: 'driver_photo_with_identity',
      },
      {
        name: 'driver_license_series',
        type: String,
        validators: [],
        labelKey: 'driver_license_series_short',
      },
      {
        name: 'driver_license_number',
        type: String,
        validators: [],
        labelKey: 'driver_license_number_short',
      },
      {
        name: 'driver_license_valid_from_date',
        type: String,
        validators: [],
        labelKey: 'driver_license_valid_from_date',
      },
      {
        name: 'driver_license_valid_until_date',
        type: String,
        validators: [],
        labelKey: 'expiration_date',
      },
      {
        name: 'driver_license_issue_date',
        type: String,
        validators: [],
        labelKey: 'issue_created_at',
      },
      {
        name: 'driver_license_issuer',
        type: String,
        validators: [],
        labelKey: 'driver_license_issuer',
      },
      {
        name: 'driver_license_experience',
        type: String,
        validators: [],
        labelKey: 'driver_license_experience',
      },
      {
        name: 'driver_license_issuer_country',
        type: String,
        validators: [],
        labelKey: 'driver_license_issuer_country',
      },
      {
        name: 'driver_license_scan',
        type: String,
        validators: [],
        labelKey: 'media.driver_license_files',
      },
      {
        name: 'driver_criminal_record_series',
        type: String,
        validators: [],
        labelKey: 'criminal_record_series_short',
      },
      {
        name: 'driver_criminal_record_number',
        type: String,
        validators: [],
        labelKey: 'criminal_record_number_short',
      },
      {
        name: 'driver_criminal_record_issue_date',
        type: String,
        validators: [],
        labelKey: 'criminal_record_issue_date_short',
      },
      {
        name: 'driver_criminal_record_issuer',
        type: String,
        validators: [],
        labelKey: 'criminal_record_issuer',
      },
      {
        name: 'driver_criminal_record_scan',
        type: String,
        validators: [],
        labelKey: 'criminal_record_scan_short',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default DriverDTO;
